import React from 'react'

import {useDashboard} from '../../contexts/DashboardContext'
import Dropdown from '../dropdown/Dropdown'
import KwotaLogo from '../KwotaLogo'
import {Menu} from './menu/Menu'
import {DropdownOptionProps} from './types'

export interface SidebarMenuProps {
  dropdownOption?: DropdownOptionProps;
  onMenuItemClick?: () => void;
}

const SidebarMenu = ({
  dropdownOption,
  onMenuItemClick
}: SidebarMenuProps) => {
  const {currentMode, menuItems} = useDashboard()
  return (
    <div className="flex flex-col flex-1 min-h-0 pt-14 lg:pt-0 bg-kwota-neutral-100">
      <div className="flex flex-col flex-1 overflow-y-auto lg:pt-8 lg:pb-4">
        <div className="flex flex-col items-center flex-shrink-0 px-6 lg:justify-center">
          <KwotaLogo url="/" className="hidden h-6 lg:block" />
          {currentMode &&
            <p className="hidden mt-1 text-xs font-bold text-center uppercase lg:block font-titillium text-kwota-neutral-800">
              {currentMode}
            </p>
          }
          {dropdownOption &&
            <div className="w-full pb-6 mt-10 space-y-2 border-b border-neutral-300">
              <label className="text-sm font-semibold text-kwota-neutral-500 font-titillium">Facility</label>
              <div className="flex items-center justify-center w-full">
                <Dropdown
                  fullWidth
                  dropdownType="primary"
                  options={dropdownOption.options}
                  selectedValue={
                    dropdownOption.selectedOption || dropdownOption.options[0]
                  }
                  setSelectedValue={dropdownOption.onSelect}
                />
              </div>
            </div>
          }
        </div>
        <nav className={`${dropdownOption ? 'mt-5' : 'mt-10'} flex-1 space-y-1 bg-kwota-neutral-100 lg:px-6`}>
          <Menu items={menuItems} onMenuItemClick={onMenuItemClick} />
        </nav>
      </div>
    </div>
  )
}

export default SidebarMenu
